const VIPTicketsIndex = () => import('./index.vue')
const VIPCreateTicketPage = () => import('./_pages/create_ticket')
const VIPTicketDetails = () => import('./_pages/details')
import { CheckAuth, CheckVIPSonkoGuard } from '@/common/guard'

export default [
    /*{ 
        path: '/ticket/:status',
        component: TicketsIndex,
        name: 'TicketsIndex'
    },*/
    { 
        path: '/vip_sonko/tickets',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPTicketsIndex,
        name: 'VIPTicketsIndex'
    },
    { 
        path: '/vip_sonko/ticket/details/:id',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPTicketDetails,
        name: 'VIPTicketDetails'
    },
    {
        path: '/vip_sonko/ticket/create',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPCreateTicketPage,
        name: 'VIPCreateTicketPage'
    }
]